<template>
  <div class="main">
    <div class="main_header" >
      <slot name="header"></slot>
    </div>
    <div class="main_center">
      <slot name="center"></slot>
    </div>
    <div class="main_footer" >
      <slot name="footer"></slot>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'layoutContainerMain'

}
</script>
<style lang="scss" scoped>
  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    margin: 20px;
    padding: 20px;
    border-radius: 6px;
    &_header {
      display: flex;
      align-items: center;
      min-height: 130px;
      border-bottom: 1px solid $border-color-base;
    }
    &_center {
      flex: 1;
      position: relative;
    }
    &_footer {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/main/index.vue